<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">Criar Cupom</h4>
      </div>
      <div></div>

        <fg-input v-if="showMatriz" name="company" label="Empresa">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione a empresa dos usuários"
            v-model="model.company"
          >
            <el-option
              v-for="option in companyList"
              class
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

        <fg-input label="Descrição">
          <textarea
            class="form-control"
            v-model="model.description"
            placeholder="Escreva aqui..."
            rows="3"
          ></textarea>
        </fg-input>
        <fg-input
            name="type"
            label="Cupom válido em :">
          <el-select
            class="select-default"
            size="large"
            v-validate="modelValidations.type"
            placeholder="Selecione um tipo"
            v-model="model.type"
          >
          
            <el-option
              v-for="option in tipo"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            ></el-option>
          </el-select>
          <div class="text-danger invalid-feedback"
            ref="alertType"
            style="display: none; margin-top: -5px">Campo obrigatório
          </div>
        </fg-input>

        <fg-input
            name="type"
            v-if="model.type === 'only_category'"
            label="Selecione a categoria">

          <el-select
            class="select-default"
            size="large"
            filterable
            placeholder="Selecione uma categoria"
            v-model="model.category"
          >
            <el-option
              v-for="option in categories"
              class="select-danger"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
          <div class="text-danger invalid-feedback"
            ref="alertCategory"
            style="display: none; margin-top: -5px">Campo obrigatório
          </div>
        </fg-input>

        <fg-input
            name="type"
            v-if="model.type === 'only_product'"
            label="Selecione o produto">

          <el-select
            class="select-default"
            size="large"
            filterable
            placeholder="Selecione um produto"
            v-model="model.product"
          >
            <el-option
              v-for="option in products"
              class="select-danger"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
          <div class="text-danger invalid-feedback"
            ref="alertProduct"
            style="display: none; margin-top: -5px">Campo obrigatório
          </div>
        </fg-input>

        <fg-input
            name="type"
            label="Tipo de cupom">
          <el-select
            class="select-default"
            size="large"
            placeholder="Selecione um tipo"
            v-model="model.value_type"
          >
          
            <el-option
              v-for="option in tipo_valor"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            ></el-option>
          </el-select>
          <div class="text-danger invalid-feedback"
            ref="alertValueType"
            style="display: none; margin-top: -5px">Campo obrigatório
          </div>
        </fg-input>

        <fg-input
          name="value"
          type='Number'
          onkeydown="javascript: return event.keyCode == 69 ? false : true"
          min="0"
          label="Valor"
          v-validate="modelValidations.value"
          v-model="model.value"
          :error="getError('value')"
        ></fg-input>

        <fg-input
          name="cota"
          label="Quantidade de utilizações"
          onkeydown="javascript: return event.keyCode == 69 ? false : true"
          min="0"
          type='Number'
          v-validate="modelValidations.cota"
          v-model="model.usage_quota"
        ></fg-input>

        <label >Periodo vigente</label>
        <div class="col-sm-6">
          <el-date-picker
            v-model="date"
            type="daterange"
            format="dd/MM/yyyy"
            align="right"
            unlink-panels
            range-separator="a"
            start-placeholder="Data de início"
            end-placeholder="Data final">
          </el-date-picker>
        </div>
          <div class="text-danger invalid-feedback"
            ref="alertPeriodo"
            style="display: none;">Campo obrigatório
          </div>

          <fg-input name="active" label="Ativo" style="margin-top: 20px">
            <div>
              <l-switch v-model="model.is_active"></l-switch>
            </div>
          </fg-input>

        <!-- <fg-input
          name="name"
          label="Nome"
          v-validate="modelValidations.name"
          v-model="model.name"
          :error="getError('name')"
        ></fg-input> -->
        
    </card>
    <card>
      <div>
        <el-button type="primary" :loading="btnLoading" 
          @click.prevent="validate">Salvar</el-button>
        <!-- <button type="submit"   class="btn btn-fill btn-info btn-wd">Salvar</button> -->
       
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option, Button, Upload, Dialog, Collapse, CollapseItem,
  Checkbox, 
  DatePicker,
  TimeSelect, } from "element-ui";
import swal from "sweetalert2";
import { Switch as LSwitch } from "src/components/index";
import { Validator } from "vee-validate";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Upload.name]: Upload,
    [Dialog.name]: Dialog,
    [Collapse.name]: Collapse,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CollapseItem.name]: CollapseItem,
    [DatePicker.name]: DatePicker,
    LSwitch
  },
  created() {
    this.crud = "Criar";
    const ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.model.company = ciaID
      this.$store.dispatch("categories/listSort",{sort: '?company=' + ciaID}).then(() => {
        this.$store.dispatch("products/listSort",{sort: '?company=' + ciaID})
        });

    } else {
    this.$store.dispatch("categories/list").then(() => {
      this.$store.dispatch("products/list")
      });
    }
    this.getListCompany()
  },
  computed: {
    categories() {
      return this.$store.state.categories.categories;
    },
    products() {
      return this.$store.state.products.products;
    },
    showItem() {
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach === 'true') {
        return true
      } else {
        return false
      }
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
  },
  data() {
    return {
      crud: "Criar",
      dialogImageUrl: "",
      companyList: [],
      btnDissmiss: false,
      btnLoading: false,
      showPrices: false,

      tipo:[{label: 'Categoria', value: 'only_category'},
            {label: 'Produto', value: 'only_product'},
            {label: 'Toda empresa', value: 'total'}],

      tipo_valor:[{label: 'Absoluto', value: 'amount'},
            {label: 'Porcentagem', value: 'percentage'}],


      date: [],
      attributes: {
        type: [],
        value: []
      },
      model: {
        category: "",
        type: "",
        product: "",
        value: '',
        value_type: "",
        description: "",
        usage_quota: 1,
        is_active: true,
        company: '',
        start_date: '',
        end_date: ''
      },
      modelValidations: {
        type: {
          required: true
        },
        category: {
          required: true
        },
        cota: {
          required: true,
        },
        valor_tipo: {
          required: true,
        },
        value: {
          required: true,
          regex: /^[0-9]+((,|.)[0-9]{2}){1}$/
        }
      }
    };
  },
  mounted () {
    this.btnDissmiss = this.$store.state.general.permission.dismiss_new_product_dialog,
    this.$watch('model.type', () => {
      this.model.category = ''
      this.model.product = ''
      this.$refs.alertType.style.display = 'none'
    })
    this.$watch('model.category', () => {
      this.$refs.alertCategory.style.display = 'none'
    })
    this.$watch('model.value_type', () => {
      this.$refs.alertValueType.style.display = 'none'
    })
    this.$watch('date', () => {
      this.$refs.alertPeriodo.style.display = 'none'
    })
    this.$watch('model.product', () => {
      this.$refs.alertProduct.style.display = 'none'
    })
    this.$watch('model.company', ()=>{
      if (this.showMatriz) {
        this.getData()
      }
    })
    if(!this.showItem) {
      this.model.company = this.$store.state.auth.company
    } 
    
  }, 
  methods: {
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
      this.btnLoading = false
    },
    notifyError() {
      this.$notify({
        message: "Erro!</br>Item não salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
      this.btnLoading = false
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getData () {
      this.$store.dispatch("categories/listSort",{sort: '?company=' + this.model.company}).then(() => {
        this.$store.dispatch("products/listSort",{sort: '?company=' + this.model.company})
        });
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },
    validate() {
      console.log('calid', this.$validator)
      this.$validator.validateAll().then(isValid => {
        if (this.model.type === '') {
          this.$refs.alertType.style.display = 'block'
        }
        if (this.model.value_type === '') {
          this.$refs.alertValueType.style.display = 'block'
          isValid = false
        }
        console.log(this.date)
        if (this.date.length == 0) {
          this.$refs.alertPeriodo.style.display = 'block'
          isValid = false
        }
        if (this.model.type === 'only_category') {
          if (this.model.category === '') {
            this.$refs.alertCategory.style.display = 'block'
            isValid = false
          }
        }
        if (this.model.type === 'only_product') {
          if (this.model.product === '') {
            this.$refs.alertProduct.style.display = 'block'
            isValid = false
          }
        }
        console.log('isvalid', isValid)
        if (isValid) {
          this.btnLoading = true
          this.model.start_date = new Date(this.date[0]).toISOString()
          this.model.end_date = new Date(this.date[1]).toISOString()
          this.model.value = this.model.value.replace(",", ".")
          this.$store.dispatch('vouchers/create', {item: this.model}).then(resp => {
            console.log('respos', resp)
            this.btnLoading = false
            this.notifySuccess();
            this.$router.push(`/app/sales/vouchers`)
          })
        }
      });
    },
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
.label-add {
  margin-top: 20px;
}
.div-img {
  padding: 15px;
  display: inline-block;
}
.remove-attribute {
  padding: 1px;
  margin-top: 30px;
}
#linha {
  width: 100%;
  border-bottom: 1px solid #c5c0c0;
}
</style>
